import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { API_BASE_URL } from 'src/apiConfig';
import CircularProgress from '@mui/material/CircularProgress';
import { cyrillicToLatin, latinToCyrillic } from 'src/helper/helperFunction';
import { MenuList } from './helper';

/* REGISTRATION STRANA  */
const RegistrationForm = ({ setIsRegistration }) => {
  const [cities, setCities] = useState([]);
  const [schools, setSchools] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedSchool, setSelectedSchool] = useState(null);
  const [schoolDetails, setSchoolDetails] = useState({
    id: '',
    name: '',
    type: '',
    zipcode: '',
    street: '',
    telephone: '',
    email: '',
    professor: ''
  });
  const [loading, setLoading] = useState(false);
  const [errorReg, setErrorReg] = useState('');
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/locations.php`);
        setCities(
          response.data.map((city) => ({
            value: city.zipcode,
            label: `${city.zipcode} - ${city.name}`
          }))
        );
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };
    fetchCities();
  }, []);

  useEffect(() => {
    const fetchSchoolOptions = async () => {
      try {
        if (selectedCity && selectedCity.value) {
          const response = await axios.get(
            `${API_BASE_URL}/api/schools.php?zip_code=${selectedCity.value}`
          );

          setSchools(
            response.data
              .filter((school) => school.zipcode === selectedCity.value)
              .map((school) => ({
                value: school.id,
                label: school.name,
                details: {
                  type: school.type,
                  name: school.name,
                  street: school.street,
                  telephone: school.telephone,
                  professor: school.professor,
                  email: ''
                }
              }))
          );

          setSchoolDetails({
            id: '',
            name: '',
            street: '',
            telephone: '',
            type: '',
            email: '',
            professor: ''
          });
        }
      } catch (error) {
        console.error('Error fetching school options:', error.message);
      }
    };
    if (selectedCity) fetchSchoolOptions();
  }, [selectedCity]);

  const handleInputChange = () => {
    setErrorReg('');
  };

  useEffect(() => {
    if (selectedSchool) {
      setSchoolDetails({
        id: selectedSchool.value,
        name: selectedSchool.details.name || '',
        street: selectedSchool.details.street || '',
        telephone: selectedSchool.details.telephone || '',
        type: selectedSchool.details.type || '',
        email: selectedSchool.details.email || '',
        professor: selectedSchool.details.professor || ''
      });
    }
  }, [selectedSchool]);

  const handleRegister = async () => {
    setLoading(true);
    if (
      !schoolDetails.name ||
      !schoolDetails.street ||
      !selectedCity ||
      !selectedSchool ||
      !schoolDetails.type ||
      !schoolDetails.email
    ) {
      const text = t('login.reqistrationReq');
      setErrorReg(text);
      setLoading(false);
      return;
    }

    try {
      const schoolResponse = await axios.get(
        `${API_BASE_URL}/api/schools.php?id=${schoolDetails.id}`
      );

      const compare = schoolResponse.data.email === schoolDetails.email;

      if (compare) {
        const usernamee = `skola${schoolDetails.id}`;
        const userResponse = await axios.post(
          `${API_BASE_URL}/api/register.php`,
          {
            username: usernamee // + '31231'
          }
        );

        if (userResponse.data.success) {
          setShowSuccessModal(true); // Prikaz pop-up poruke
        } else {
          setErrorReg(t('login.registrationError'));
          console.error('Neuspešna registracija:', userResponse.data.error);
        }
      } else {
        setErrorReg(t('login.registrationError'));
        console.error('Neuspešno dodavanje škole:', schoolResponse.data);
      }
    } catch (error) {
      setErrorReg(t('login.generalError'));
      console.error('Greška prilikom registracije:', error.message);
    }
    setLoading(false);
  };

  const showSuccessPopup = () => {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 999
        }}
      >
        <div
          style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '40px',
            width: '400px',
            textAlign: 'center',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
            position: 'relative'
          }}
        >
          <h2
            style={{
              fontSize: '24px',
              fontWeight: 'bold',
              marginBottom: '20px'
            }}
          >
            Успешна регистрација
          </h2>
          <p style={{ fontSize: '16px', marginBottom: '30px' }}>
            Лозинка и корисничко име су Вам успешно послати на мејл.
          </p>
          <button
            onClick={() => {
              setShowSuccessModal(false);
              setIsRegistration(false);
            }}
            style={{
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              fontSize: '16px',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            Потврди
          </button>
        </div>
      </div>
    );
  };

  const handleSignIn = async (event) => {
    event.preventDefault();
    setErrorReg('');
    await handleRegister();
  };

  return (
    <div className="form-container sign-up">
      <form onSubmit={handleSignIn}>
        <h1>{t('login.register')}</h1>
        <span>{t('login.useEmailForRegistration')}</span>

        <Select
          value={selectedCity}
          onChange={(e) => {
            setSelectedCity(e);
            setSelectedSchool(null);
            handleInputChange();
          }}
          options={cities}
          placeholder={t('login.selectCity')}
          className="select-register"
          components={{ MenuList: MenuList }}
          filterOption={(option, inputValue) => {
            const optionLabel = cyrillicToLatin(option.label.toLowerCase());
            const optionLabelCyrillic = latinToCyrillic(
              option.label.toLowerCase()
            );
            const input = cyrillicToLatin(inputValue.toLowerCase());
            const inputCyrillic = latinToCyrillic(inputValue.toLowerCase());

            return (
              optionLabel.includes(input) ||
              optionLabelCyrillic.includes(inputValue.toLowerCase()) ||
              option.label.toLowerCase().includes(inputValue.toLowerCase())
            );
          }}
        />
        <Select
          value={selectedSchool}
          onChange={(e) => {
            setSelectedSchool(e);
            setSchoolDetails({
              id: e.value,
              name: e.details.name || '',
              street: e.details.street || '',
              telephone: e.details.telephone || '',
              type: e.details.type || '',
              email: e.details.email || '',
              professor: e.details.professor || ''
            });
            handleInputChange();
          }}
          options={schools}
          placeholder={t('login.selectSchool')}
          className="select-register"
          filterOption={(option, inputValue) => {
            const optionLabel = cyrillicToLatin(option.label.toLowerCase());
            const optionLabelCyrillic = latinToCyrillic(
              option.label.toLowerCase()
            );
            const input = cyrillicToLatin(inputValue.toLowerCase());
            const inputCyrillic = latinToCyrillic(inputValue.toLowerCase());

            return (
              optionLabel.includes(input) ||
              optionLabelCyrillic.includes(inputValue.toLowerCase()) ||
              option.label.toLowerCase().includes(inputValue.toLowerCase())
            );
          }}
        />
        <input
          type="text"
          value={schoolDetails.name}
          placeholder={t('login.schoolName')}
          readOnly
        />
        <input
          type="text"
          value={schoolDetails.street}
          placeholder={t('login.schoolStreet')}
          readOnly
        />
        <input
          type="text"
          value={schoolDetails.telephone}
          placeholder={t('login.schoolTelephone')}
          readOnly
        />
        <input
          type="text"
          placeholder={t('login.teacher')}
          value={schoolDetails.professor}
          onChange={(e) =>
            setSchoolDetails((prevState) => ({
              ...prevState,
              professor: e.target.value
            }))
          }
        />
        <input
          type="email"
          placeholder={t('login.schoolEmail')}
          value={schoolDetails.email}
          onChange={(e) => {
            setSchoolDetails((prevState) => ({
              ...prevState,
              email: e.target.value
            }));
            handleInputChange();
          }}
        />
        {errorReg !== '' && <p className="error-message">{errorReg}</p>}
        {loading ? (
          <CircularProgress />
        ) : (
          <button type="submit">{t('login.signUpButton')}</button>
        )}
      </form>

      {showSuccessModal && showSuccessPopup()}
    </div>
  );
};

export default RegistrationForm;
